import { toast } from 'react-toastify';
import { CA, CartItemTypes } from '../components/common/constants';

const getAgreementError = (
    selectedAgreement: string,
    country: string,
    cartItemTypeId: number
) => {
    if (
        selectedAgreement.length === 0 &&
        country === CA &&
        cartItemTypeId === CartItemTypes.Accessory
    ) {
        toast.error('Please select a Benefit to add to cart', {
            position: 'bottom-right',
            autoClose: 10000,
        });
        return true;
    }
};
export default getAgreementError;
